<template>
    <div class="box" v-title data-title="德木简介">
        <div class="title">江苏德木供应链管理有限公司简介</div>
        <div class="introduceTitle">关于德木</div>
        <div class="introduce">江苏德木供应链管理有限公司是专注木材企业信息化、网络化、数字化解决方案的服务供应商，公司致力于围绕木材用户需求，从行业痛点出发，通过对木材全产业链全场景链路SaaS产品的研发，围绕企业数字化管理、金融在线化赋能、大数据决策支持等多维度帮助木材全产业链企业实现数字化科学管理，在线化高效协同，数据化严谨决策，让企业管理更简单。</div>
        <div class="introduceTitle">企业愿景</div>
        <div class="introduce">帮助广大木材企业用户实现数字化升级转型，引领木材行业走向产业互联网，成为木材行业最有价值、最值得信赖的技术服务供应商。</div>
        <div class="introduceTitle">企业使命</div>
        <div class="introduce">让木材企业管理更简单</div>
        <div class="introduceTitle">企业理念</div>
        <div class="introduce">开放、融合、赋能、共成</div>
        <div class="introduceTitle">企业核心价值观</div>
        <div class="introduce">以用户价值为核心，用心服务、传递价值</div>
        <div class="introduceTitle">主要产品与服务</div>
        <el-row class="row" justify="center">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/8.jpg" alt="" />
                <p class="text">松木贸易商ERP进销存管理系统</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/2.png" alt="" />
                <p class="text">木材WMS仓库管理系统</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/3.png" alt="" />
                <p class="text">金融FS系统</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/4.png" alt="" />
                <p class="text">硬木ERP进销存管理系统</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/5.png" alt="" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/6.png" alt="" />
                <p class="text">德木在线供应链金融服务</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <img class="img" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/denuSynopsis/7.png" alt="" />
                <p class="text">得木云链数据信息服务</p>
            </el-col>
        </el-row>

        <div class="companyLink">企业网址：<a class="link" href="https://www.dwood168.com/">www.dwood168.com</a> <a class="link" href="https://www.woodn1.com/">www.woodn1.com</a></div>
        <div class="contactFotter">各系统销售客服联系方式：</div>
        <div class="contactInformation">
            <div class="contactTitle">一、 谱木云ERP(硬木系统)</div>
            <div class="text">唐新宇：17712686596</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">二、德木云ERP(松木系统)</div>
            <div class="text">唐新宇：17712686596</div>
            <div class="text">杜卫红：13812919274</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">三、仓储系统WMS(木材仓库管理系统)</div>
            <div class="text">唐新宇：17712686596</div>
            <div class="text">杜卫红：13812919274</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">四、金融系统FS</div>
            <div class="text">姚凯：13636535807</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">五、德木供应链金融服务</div>
            <div class="text">姚凯：13636535807</div>
        </div>
        <div class="contactInformation">
            <div class="contactTitle">六、得木云链在线数据信息服务</div>
            <div class="text">姚凯：13636535807</div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        
    },
    data(){
        return{
            
        }
    },
    methods:{
        
    }
}
</script>

<style scoped>
    .box{
        max-width: 120rem;
        margin: 0 auto;
        padding: 3rem 1rem;
    }
    .box>.title{
        font-size: 2.2rem;
        font-weight: bold;
        text-align: center;
        margin-bottom: 1.8rem;
    }
    .box .introduceTitle{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
        font-weight: bold;
    }
    .box .introduce{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .row{
        padding: 2rem 0;
    }
    .row>.el-col{
        text-align: center;
        padding: 1.5rem 0;
    }
    .el-col .img{
        display: inline-block;
        width: 100%;
        height: 100%;
    }
    .el-col .text{
        text-align: left;
        color: #666;
        font-size: 1.4rem;
    }
    .companyLink{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .companyLink .link{
        margin: 0 1.2rem;
    }
    .contactFotter{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .contactInformation{
        padding-bottom: 1.5rem;
    }
    .contactInformation .contactTitle{
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.4rem 0;
    }
    .contactInformation .text{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.4rem 0;
    }
    .appendix{
        margin-top: 2rem;
    }
    .appendix .title{
        line-height: 2.8rem;
        font-size: 1.6rem;
    }
    .appendix .com{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
    .controll{
        margin-top: 2rem;
    }
    .controll .title{
        line-height: 2.8rem;
        font-size: 1.6rem;
    }
    .controll ul li{
        text-indent: 3.4rem;
        line-height: 2.8rem;
        font-size: 1.6rem;
        padding: 0.6rem 0;
    }
</style>